import React from 'react';
import styles from './IekArticleList.styl';

class IekArticleList extends React.Component
{
	render() {
		if (!this.props.items) {
			return (<div className={this.props.wrapStyle}></div>);
		}

		const rows = this.props.items.map((item, index) => {
			let rowClassName = index % 2 === 0 ? styles.rowEven : styles.rowOdd;

			if (this.props.selectedItem && this.props.selectedItem.article === item.article) {
				rowClassName = styles.rowSelected;
			}

			const isSeparator = /^_separator/.test(item.article);

			if (isSeparator)
			{
				return (
					<tr key={item.article+index}>
						<td colSpan="2" className={styles.separatorCell}></td>
					</tr>
				);
			}

			return (
				<tr key={item.article+index} className={rowClassName} onDoubleClick={()=> this.props.onNameArticleDoubleClick(item)} onClick={() => this.props.onSelect && this.props.onSelect(item)}>
					<td className={this.props.articleCellStyle ? this.props.articleCellStyle : styles.articleCell}>{item.articleTitle ? item.articleTitle : item.article}</td>
					<td className={this.props.cellStyle ? this.props.cellStyle : styles.cell}>

						{this.props.nameType && this.props.nameType === 'num' ? <input type="text" value={item.name} className={styles.num} onChange={event => this.props.onNumChange({item: item, index, value: event.target.value})} /> : item.name}

						{this.props.deleteStyle && <div className={this.props.deleteStyle} onClick={event => { event.stopPropagation(); this.props.onDelete({item: item, index}); }}></div>}
					</td>
				</tr>
			);
		});

		return (
			<div className={this.props.wrapStyle}>
				<div className={this.props.tableWrapStyle}>
					<table className={styles.table}>
						<tbody>{rows}</tbody>
					</table>
				</div>
			</div>
		);
	}
}

export default IekArticleList;



// WEBPACK FOOTER //
// ./src/react/ui/IekArticleList.jsx